import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import {
  Box,
  Button,
  DialogActions,
  Divider,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles({
  actions: {
    padding: 15,
  },
});

export const UpdatesWillBeCommitedDialog: React.FC<{
  open: boolean;
  onClose: (value: number) => void;
}> = ({ open, onClose }) => {
  const classes = useStyles();
  const handleClose = () => {
    onClose(0);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="changes-committed-dialog-title">
        Changes Will Be Committed Immediately
      </DialogTitle>
      <Divider />
      <Box p={3}>
        <Typography variant="body1" component="p">
          Please note that clicking the commit button will cause all changes to
          be committed immediately, if you are unsure press the cancel button
          and review all settings.
        </Typography>
      </Box>
      <DialogActions className={classes.actions}>
        <Button
          onClick={() => onClose(1)}
          color="primary"
          data-test="commit-changes-committed-dialog"
        >
          Commit
        </Button>
        <Button
          onClick={() => onClose(0)}
          color="primary"
          data-test="cancel-changes-committed-dialog"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
